// traceability: requirements: [NFR-001, NFR-015]
import { Outlet } from 'react-router-dom';
import { useDirection } from '@/i18n/useDirection';
import { useTheme } from '@/hooks/useTheme';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ToastProvider } from '@/components/ui/Toast';
import { AuthProvider } from '@/features/auth/AuthContext';

export function App() {
  useDirection();
  useTheme();

  return (
    <ErrorBoundary>
      <AuthProvider>
        <div className="flex min-h-screen flex-col">
          <Header />
          <main className="flex-1">
            <Outlet />
          </main>
          <Footer />
        </div>
        <ToastProvider />
      </AuthProvider>
    </ErrorBoundary>
  );
}
